export const BgColors = {
  bgColors: {
    bgPrimary0: "#1A1A1A",
    bgPrimary100: "#0A0A0A",
    bgPrimary200: "#4A4A4A",
    bgPrimary300: "#2A2A2A",
    bgPrimary400: "#3A3A3A",
    bgPrimary500: "#4A4A4A",
    bgPrimary600: "#5A5A5A",
    bgPrimary900: "#6A6A6A",
    bgPrimary1000: "#FFFFFF",

    bgBoxes:"#1A1A1A",
    bgRadial: "#535353",
    bgCockpitBar: "#FFFFFF",
    bgClixBar: "#5d5d5d",
    bgPlainBtn:"#2A2A2A",
    bgCircle:"#FFFFFF",
    bgProgressHover: "#5A5A5A",
    bgBar: "#0A0A0A",
    bgMuted: "#2f2f2f",
    bgAnalyseBtnActive: "#4A4A4A",
    bgAnalyseButton: "#FFFFFF",
    bgAnalyseTop: "#4A4A4A",
    bgAnalyseCenterC: "#FFFFFF", 
    bgAnalyseCenter: "#4A4A4A",
    bgAiBtnSelected:"#202020",
    bgAiBtnHover: "#3A3A3A",
    bgAiBtn: "#606060",
    bgFilter: "#2A2A2A",
    bgLoginService: "#000000",
    bgSwitchOn: "#f1f1f1",
    bgSwitchOff: "#969696",
    bgDeleteBtn: "#303030",
    bgPlayBtn: "#303030",
    bgEditBtn: "#303030",
    bgDnd: "#2f2f2f",
    bgModal: "#4A4A4A",
    bgModalError: "#2F2F2F",
    bgModalSuccess: "#2F2F2F",
    bgModalWarning: "#2F2F2F",
    bgMenu: "#4A4A4A",

    bgStatusError: "#FFFFFF",
    bgStatusTrue: "#44FF44",
    bgStatusInfo: "#4444FF",

    bgProgress20: "#1A1A1A",
    bgProgress40: "#4A4A4A",
    bgProgress60: "#FFB800",
    bgProgress80: "#A8FF33",
    bgProgress100: "#202020",
    bgProgress120: "#000000",

    bgToastProgress: "#FFFFFF",
    bgContrastProgress: "#EEEEEE",

    bgBlue50: "#000000",
    bgBlue100: "#2f2f2f",
    bgBlue150: "#222222",
    bgBlue200: "#333333",
    bgBlue300: "#6A6A6A",
    bgBlue1000: "#303030",
    bgYellow1000: "#f1f1f1",

    bgLightGreen: "#90EE90",
    bgLightYellow: "#303030",
    bgLightPink: "#5A5A5A",
    bgDanger:"#FFFFFF"
  },
};